import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LookupContext = createContext(null);

const EMPTY = { properties: [], rooms: [], tenants: [], vendors: [], contracts: [], landlords: [] };

export function LookupProvider({ children }) {
  const { user } = useAuth();
  const [lookups, setLookups] = useState(EMPTY);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const [p, r, t, v, c, ll] = await Promise.all([
        api.get("/properties"),
        api.get("/rooms"),
        api.get("/tenants"),
        api.get("/vendors"),
        api.get("/contracts"),
        api.get("/landlords").catch(() => ({ data: [] })),
      ]);
      setLookups({
        properties: p.data, rooms: r.data, tenants: t.data, vendors: v.data, contracts: c.data, landlords: ll.data,
      });
    } catch {}
  }, [user]);

  useEffect(() => {
    if (user) refresh();
  }, [user, refresh]);

  const nameOf = useCallback((type, id) => {
    if (!id) return "-";
    const list = lookups[type] || [];
    const item = list.find((x) => x.id === id);
    if (!item) return "-";
    if (type === "properties") return item.name;
    if (type === "rooms") return item.room_number;
    if (type === "tenants") return item.name;
    if (type === "vendors") return item.name;
    if (type === "contracts") return item.contract_number;
    return item.name || "-";
  }, [lookups]);

  return (
    <LookupContext.Provider value={{ lookups, refresh, nameOf }}>
      {children}
    </LookupContext.Provider>
  );
}

export function useLookups() {
  return useContext(LookupContext);
}
